export const breakpoint = {
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xl2: 1600,
  xl3: 2000,
  xl4: 2600,
  xl5: 3200,
};

export const breakpointHeight = {
  sm: 400,
  md: 600,
  lg: 800,
  xl: 1000,
  xl2: 1200,
  xl3: 1400,
  xl4: 1600,
  xl5: 1800,
};
